import React from 'react';
import { getPhoneMask } from '../../utils/InputMaskUtils';
import MaskedInput from 'react-text-mask';

const PhoneMaskedInput = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={getPhoneMask()}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export default PhoneMaskedInput;
